import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gender'
})
export class GenderPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value && value.toLowerCase() === 'f' ? 'Female' : value && value.toLowerCase() === 'm' ? 'Male' : value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/gender.pipe.ts